import { useRouter } from 'next/router';

import type { NextPage } from 'next';

const Home: NextPage = () => {
  const router = useRouter();
  router.push({
    pathname: '/trade',
    query: router.query,
  });

  return null;
};

export default Home;
